import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetCustomersPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/get-customers-paginated.form-default-values';
import { GetCustomersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/get-customers-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterSearchCustomerListContextProvider,
  useCustomerListContext,
} from '../customer.context';
import { CustomerListFilterSearchFormController } from './customer-list-filter-search-form/customer-list-filter-search-form.controller';

interface CustomerListFilterSearchControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const CustomerListFilterSearchController = ({
  onCancel,
  onSuccess,
}: CustomerListFilterSearchControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useCustomerListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetCustomersPaginatedModel> = (
    errors,
  ) => {
    Logger.error(errors);
    toast.error(
      t('$.customer-list-filter-search.error', { error: t('global.unknown') }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<
    GetCustomersPaginatedModel
  > = (fieldValues) => {
    setGetPaginatedQueryParameters((current) => {
      return {
        ...current,
        textToSearch: fieldValues.textToSearch,
      };
    });
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetCustomersPaginatedDefaultValues(
    getPaginatedQueryParameters,
  );

  return (
    <FilterSearchCustomerListContextProvider data={data}>
      <CustomerListFilterSearchFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </FilterSearchCustomerListContextProvider>
  );
};
